import { ArchivingFingerprint }       from '@app/modules/archiving/models/archiving-common.model';
import { OpenArchiveEntityConfig }    from '@app/modules/archiving/presets/open-archive/open-archive-entity-config.model';
import { User }                       from '@app/modules/user/models/user.model';
import { RequestCompleteEntityState } from '@core/interfaces/api.interface';
import { IOpenArchiveEntityEvents }   from '@core/interfaces/entity.interface';
import { EntityActionEventEnum }      from '@models/entity.model';
import { Observable }                 from 'rxjs';

// ENUMS #############################################################
// API enums *********************************************************
export enum OpenArchiveStatusEnum {
	ARCHIVED = 'archived',
	MALWARE_FOUND = 'malwareFound',
	MALWARE_SCANNING = 'malwareScanning'
}

// UI enums *********************************************************


export enum OpenArchivePresetEnum {
	BUSINESS_PREMISES_DETAIL_ARCHIVING_OPEN_ARCHIVE = 'businessPremisesDetailArchivingOpenArchive',
	BULK_EXPORT_MODAL = 'bulkExportModal',
	BULK_KEYWORD_MODAL = 'bulkKeywordModal'
}

export enum OpenArchiveActionEntityIdentifierEnum {
	KEYWORD = 'keyword',
	OPEN_ARCHIVE = 'openArchive'
}


// INTERFACES ########################################################
// API interfaces ****************************************************
// UI interfaces *****************************************************
export interface IOpenArchiveDetailsUserRequestData {
	userIds: string[];
	userReqs$: Observable<RequestCompleteEntityState<User>>[];
}

export interface IOpenArchiveEntityActionEvent {
	action: EntityActionEventEnum;

	actionForEntity: OpenArchiveActionEntityIdentifierEnum;

	openArchive: OpenArchive;

	openArchiveEntityConfig?: OpenArchiveEntityConfig;
}


// TYPES ############################################################
export type OpenArchiveProps = ( keyof OpenArchive )[];

// ENTITIES ##########################################################
// MODEL USED FOR TRANSITION APP<->API (TransitionalModelObject)
export class OpenArchiveTMO {

	businessPremisesId?: string = undefined;

	created?: Date = undefined;

	createdBy?: string = undefined;

	fingerprint?: ArchivingFingerprint = undefined;

	public id?: string = undefined;

	keywordId?: string = undefined;

	lastModifiedBy?: string = undefined;

	lastModified?: Date = undefined;

	name?: string = undefined;

	status?: OpenArchiveStatusEnum = undefined;
}

// MODEL USED IN APPLICATION (with additional properties)
export class OpenArchive extends OpenArchiveTMO {
	public ui?: IOpenArchiveEntityEvents = {};
	public isSelected?: boolean = undefined;
	public selectedKeywordId?: string = undefined;
}
